import { format } from 'date-fns'

import { formatMoney, sanitizeDocumentInPriceInput } from 'helpers/helpers'

// id is ExpenseResponse.amountDetails[].payment_type_id (1 = cash, 2 = terminal, as on the cheques page);
// key is the field name in CreateExpenseRequest and ExpenseOpenCashboxDto
export const PAYMENT_TYPES = [
	{ id: 1, key: 'cashAmount', i18n: 'CASH', icon: 'uil-money-bill' },
	{ id: 2, key: 'terminalAmount', i18n: 'CARD', icon: 'uil-credit-card' },
]

// ids are the same as on the cheques/currency pages: 1 = so'm, 2 = USD
export const CURRENCIES = [
	{ id: 1, name: 'UZS' },
	{ id: 2, name: '$' },
]

export const EXPENSE_STATUSES = {
	SUCCESS: { i18n: 'SUCCESS', className: 'fo-status-success' },
	CANCELED: { i18n: 'FO_CANCELED', className: 'fo-status-canceled' },
}

// ExpenseResponse.status: CANCELED / CANCELLED is canceled, anything else is SUCCESS
export function expenseStatus(expense) {
	return /^CANCEL/i.test(expense.status || '') ? 'CANCELED' : 'SUCCESS'
}

// amountDetails with a known payment type, in PAYMENT_TYPES order (cash, terminal)
export function expenseDetails(expense) {
	return (expense.amountDetails || [])
		.map(detail => ({ ...detail, paymentType: PAYMENT_TYPES.find(item => item.id === detail.payment_type_id) }))
		.filter(detail => detail.paymentType)
		.sort((a, b) => PAYMENT_TYPES.indexOf(a.paymentType) - PAYMENT_TYPES.indexOf(b.paymentType))
}

export function currencyLabel(currencyId, currencyName) {
	return CURRENCIES.find(currency => currency.id === currencyId)?.name || currencyName || ''
}

export function formatAmount(amount, currency) {
	const value = Number(amount) || 0
	return `${formatMoney(value, Number.isInteger(value) ? 0 : 2)} ${currency}`
}

// "5 000 000,505" -> "5000000.50": digits and one decimal separator, at most 2 decimals
export function parseAmountInput(value) {
	return sanitizeDocumentInPriceInput(value).replace(/(\.\d{2})\d+$/, '$1')
}

export function formatTime(date) {
	try {
		return date ? format(new Date(date), 'HH:mm') : ''
	} catch (error) {
		return ''
	}
}

export function responsibleName(expense) {
	return [expense.firstName, expense.lastName].filter(Boolean).join(' ') || expense.userLogin || ''
}

// cash + terminal
export function expenseTotal(expense) {
	return (expense.amountDetails || []).reduce((sum, detail) => sum + (Number(detail.amount) || 0), 0)
}

// expense-total rows in CURRENCIES order (UZS, USD, others), "0 UZS" when there are none
export function sortTotals(totals) {
	if (totals.length === 0) {
		return [{ currencyId: CURRENCIES[0].id, amount: 0 }]
	}
	const order = (total) => {
		const index = CURRENCIES.findIndex(currency => currency.id === total.currencyId)
		return index === -1 ? CURRENCIES.length : index
	}
	return [...totals].sort((a, b) => order(a) - order(b))
}
